import React from 'react';

const Skeleton = ({ className = '', as: Component = 'div' }) => (
  <Component
    className={`animate-pulse rounded-md bg-slate-200/80 ${className}`}
    aria-hidden="true"
  />
);

export const SkeletonText = ({ className = '' }) => (
  <Skeleton className={`h-3 ${className}`} />
);

export default Skeleton;
